import type React from "react";
import { Bell } from "lucide-react";
import { useNavigate } from "react-router";
import { useNewNotifications } from "@/hooks/useNewNotifications";
import { usePreference } from "@/contexts/PreferencesContext";
import { ROUTE_NOTIFICATIONS } from "@/utils/const";
import { withNavJump } from "@/lib/nav/backTracker";

/**
 * PRODUCT_DEV-376: 通知ベル（MainHeader の右上に置く共通部品）。
 * 旧 HomeHeader / MyCustomers 一覧に重複していたベルを一本化。
 * タップで通知画面へ遷移し、バッジ既読時刻を更新する。
 */
export const NotificationBellButton: React.FC = () => {
  const navigate = useNavigate();
  const { badgeCount } = useNewNotifications();
  // PRODUCT_DEV-699: バッジの既読時刻は個人設定（サーバ）。端末を変えても持ち越される。
  const [, setViewedAt] = usePreference("notificationViewedAt", "");

  return (
    <button
      type="button"
      aria-label="通知"
      onClick={() => {
        setViewedAt(new Date().toISOString());
        navigate(ROUTE_NOTIFICATIONS, { state: withNavJump() });
      }}
      className="relative grid place-items-center w-9 h-9 text-neutral-700"
    >
      <Bell size={22} />
      {/* 未読バッジ: Ph1.80 §4.5-J 準拠（赤ピル #EF4444=red-500・白リング 1.5px・17px・白文字 10px/700） */}
      {badgeCount > 0 && (
        <span className="absolute top-[3px] right-[3px] min-w-[17px] h-[17px] px-1 bg-red-500 text-white text-[10px] font-bold rounded-full ring-[1.5px] ring-white flex items-center justify-center leading-none">
          {badgeCount > 99 ? "99+" : badgeCount}
        </span>
      )}
    </button>
  );
};

export default NotificationBellButton;
